import { getURLParameter } from "../../../../../lib/html5-software-library/src/ranj/util/URLUtil";

export default class DebugModel {
    /**
     * @returns {boolean}
     */
    static get fasterAnimations() {
        return getURLParameter('fast') == '1';
    }

    /**
     * @returns {boolean}
     */
    static get skipIntro() {
        return getURLParameter('skipIntro') == '1';
    }

    /**
     * @returns {string}
     */
    static get chapter() {
        return getURLParameter('chapter');
    }

    /**
     * @returns {number}
     */
    static get maxTurns() {
        const maxTurnsString = getURLParameter('maxTurns');
        try {
            const maxTurns = parseInt(maxTurnsString);
            return maxTurns;
        } catch (e) {
            return undefined;
        }
    }

    /**
     * @returns {boolean}
     */
    static get debugContent() {
        return getURLParameter('debugContent') == '1';
    }

    /**
     * @returns {boolean}
     */
    static get skipVideos() {
        return getURLParameter('skipVideos') == '1';
    }

    /**
     * @returns {boolean}
     */
    static get playerName() {
        return getURLParameter('playerName');
    }

    static hasPlayerNameOverride() {
        return !!this.playerName;
    }

    /**
     * @returns {string}
     */
    static get scenario() {
        return getURLParameter('scenario');
    }

    static hasScenarioOverride() {
        return !!this.scenario;
    }

    static get gotoEnd() {
        return getURLParameter('gotoEnd') == '1';
    }

    static hasTrustOverride() {
        return getURLParameter('trust') !== undefined && getURLParameter('trust') !== null;
    }

    static get trust() {
        return parseInt(getURLParameter('trust'));
    }

    static hasGroupSpiritOverride() {
        return getURLParameter('groupSpirit') !== undefined && getURLParameter('groupSpirit') !== null;
    }

    static get groupSpirit() {
        return parseInt(getURLParameter('groupSpirit'));
    }

    static get minReflectionTurns() {
        return parseInt(getURLParameter('minReflectionTurns'));
    }

    static get maxReflectionTurns() {
        return parseInt(getURLParameter('maxReflectionTurns'));
    }

    static get crash() {
        return getURLParameter('crash') == '1';
    }

    static get phase() {
        return getURLParameter('phase');
    }

    static get clearSavegame() {
        return getURLParameter('clearSavegame') == '1';
    }

    static hasLanguageOverride() {
        return getURLParameter('lang') !== undefined && getURLParameter('lang') !== null;
    }

    static get languageOverride() {
        return getURLParameter('lang') || 'nl';
    }

    static get mockPlatform() {
        return getURLParameter('mockPlatform') == '1';
    }
}